export const CRUD_READ_PENDING = 'CRUD_AGE_RANGES_READ_PENDING'
export const CRUD_READ_SUCCEEDED = 'CRUD_AGE_RANGES_READ_SUCCEEDED'
export const CRUD_READ_FAILED = 'CRUD_AGE_RANGES_READ_FAILED'
